import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
export function toNanoTon(amountStr: string) {
    // Преобразуем строку в число с плавающей запятой
    const amount = parseFloat(amountStr);

    // Умножаем на 10^9 и приводим к целому числу
    const nanoTonAmount = Math.floor(amount * 1e9); // Можно использовать `Math.floor` или `Math.round` в зависимости от нужного округления

    return nanoTonAmount;
}
